import React from 'react';
import Checkmark from '../icons/checkmark';
import Disabled from '../icons/disabled';
import {
  Breakpoints,
  DisableFocusContainer,
  TextAlignment,
  TextAppearance,
  TextColor,
  TextCustom,
  TextSize,
  TextTag,
  TextWeight,
} from '@vw-marketing/us-components';
import {
  StyledColorFilterWrapper,
  StyledCheckboxContainer,
  StyledLabelContainer,
  StyledColorBorder,
  StyledColorImage,
  StyledCheckmark,
  StyledDisabled,
} from './styled';

interface FilterColorProps {
  readonly label: React.ReactNode;
  readonly value: string;
  readonly onClick?: () => void;
  readonly checked?: boolean;
  readonly isDisabled?: boolean;
  readonly color?: string;
}

export const FilterCheckColor: React.FC<FilterColorProps> = (props) => {
  const { label, onClick, checked, isDisabled, color} = props;

  return (
    <StyledColorFilterWrapper onClick={!isDisabled ? onClick : undefined}>
      <DisableFocusContainer>
        <StyledCheckboxContainer isDisabled={isDisabled}>
          <StyledColorBorder checked={checked}>
            {isDisabled ? (
              <StyledDisabled>
                <Disabled iconSize={65} fillColor={color}/>
              </StyledDisabled>
            ) : (
              <>
                <StyledCheckmark checked={checked}>
                  <Checkmark iconSize={20} />
                </StyledCheckmark>
                <StyledColorImage background={color} />
              </>
            )}
          </StyledColorBorder>
          <StyledLabelContainer>
            <TextCustom
              appearance={TextAppearance.headline200}
              tag={TextTag.span}
              style={{
                [Breakpoints.default]: {
                  color: TextColor.inherit,
                  fontSize: TextSize.TextSize12,
                  textAlign: TextAlignment.center,
                  fontWeight: TextWeight.regular,
                },
              }}
            >
              {label}
            </TextCustom>
          </StyledLabelContainer>
        </StyledCheckboxContainer>
      </DisableFocusContainer>
    </StyledColorFilterWrapper>
  );
};
